<template>
  <div class="map-container">
    <!-- control box ko as normal div hi rakho -->
    <div
      v-show="!isMap"
      ref="controlBox"
      class="control-box"
    >
      <div
        v-if="!isLoading"
        class="mapTabsWrap"
      >
        <v-tabs
          v-model="tab"
          class="customTab"
        >
          <div class="d-flex justify-space-between">
            <v-tab
              v-for="item in items"
              :key="item.tab"
            >
              {{ item.tab }}
            </v-tab>
            <div
              class="toggle-btn"
              @click="isControl = !isControl"
            >
              <v-icon>
                {{ isControl ? "mdi-arrow-up-thick" : "mdi-arrow-down-thick" }}
              </v-icon>
            </div>
          </div>
        </v-tabs>
        <transition name="slide-fade">
          <v-tabs-items
            v-if="isControl"
            v-model="tab"
          >
            <v-tab-item
              v-for="item in items"
              :key="item.tab"
            >
              <!-- ✅ All Vehicles -->
              <div v-if="item.content === 'allStations'">
                <div class="vehicles-listing">
                  <div class="tabs-header top-filters">
                    <v-card class="searchField">
                      <v-text-field
                        v-model="searchLoc"
                        label="Search"
                        filled
                        dense
                        clearable
                      />
                    </v-card>
                  </div>
                  <div
                    class="row-items"
                    @wheel.stop
                  >
                    <div class="row-item">
                      <v-checkbox
                        v-model="isSelectedAll"
                        :input-value="isAllSelected"
                        :label="isAllSelected ? 'Unselect All' : 'Select All'"
                        @click="selectionChange(isAllSelected)"
                      />
                    </div>
                    <div
                      v-for="loc in filteredLocations"
                      :key="loc.id"
                      class="row-item"
                    >
                      <v-checkbox
                        :input-value="loc.selected"
                        :label="loc.name"
                        @click="addToMap(loc)"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- ✅ Filters -->
              <div v-if="item.content === 'filters'">
                <v-container class="top-filters">
                  <v-row>
                    <v-col
                      v-if="authUser.isAdmin"
                      cols="6"
                      class="pb-0"
                    >
                      <v-select
                        v-model="tempFilters.tenant_id"
                        :items="tenantsOptions"
                        label="Tenant Name"
                        dense
                        filled
                        item-value="id"
                        item-text="name"
                        clearable
                      />
                    </v-col>
                    <v-col
                      v-if="
                        !(
                          ['CSO', 'cso'].includes(authUser.user_nature) &&
                          authUser.cso_client_id
                        )
                      "
                      cols="6"
                      class="pb-0"
                    >
                      <v-select
                        v-model="tempFilters.cso_client_id"
                        :items="tempFilters.tenant_id ? csoClientsList : []"
                        label="CSO CLient"
                        dense
                        filled
                        item-value="id"
                        item-text="business_name"
                        clearable
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <v-select
                        v-model="tempFilters.charger_type"
                        :items="['ac', 'dc']"
                        label="Charger Type"
                        dense
                        filled
                        clearable
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <v-select
                        v-model="tempFilters.charger_capacity"
                        :items="['30', '60', '120']"
                        label="Charger Capacity"
                        dense
                        filled
                        clearable
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <v-select
                        v-model="tempFilters.connector_type"
                        :items="['CCS', 'CCS2', 'CHAdeMO']"
                        label="Connector Type"
                        dense
                        filled
                        clearable
                      />
                    </v-col>

                    <v-col cols="6">
                      <v-btn
                        color="primary"
                        class="m-0"
                        @click="applyFilters"
                      >
                        Apply
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </transition>
      </div>
    </div>

    <!-- ✅ Google Map -->
    <GmapMap
      ref="gmap"
      :center="mapCenter"
      :zoom="4"
      :options="mapOptions"
      style="width: 100%; height: 93vh"
      @click="() => (infoWindowOpened = false)"
    >
      <gmap-custom-marker
        v-for="(v, index) in locationsForMap"
        :key="index"
        :marker="{ lat: v.latitude, lng: v.longitude }"
      >
        <div
          class="pin-icon-container"
          :class="v.location_status"
          @click.stop="showInfo(v)"
        >
          <div
            class="pin-title"
            :title="v.name"
          >
            {{ v.name }}
          </div>
          <div class="pin-circle">
            <v-icon>mdi-ev-station</v-icon>
          </div>
          <div class="pin-arrow" />
        </div>
      </gmap-custom-marker>

      <GmapInfoWindow
        :position="infoWindowPosition"
        :opened="infoWindowOpened"
        @closeclick="infoWindowOpened = false"
      >
        <div class="info-window">
          <div>
            <span>Tenant Name:</span>
            <span>{{ infoWindowContent.tenant_name }}</span>
          </div>
          <div>
            <span>Address:</span>
            <span>
              <Typography
                :text="infoWindowContent.address"
                text-clip
              />
            </span>
          </div>
          <div>
            <span>Contact:</span>
            <span>
              {{ infoWindowContent.country_code }}-{{
                infoWindowContent.phone_number
              }}
            </span>
          </div>
          <div>
            <span>Charger Type:</span>
            <span> {{ infoWindowContent.charger_type }} </span>
          </div>
          <div>
            <span>Charger Capacity:</span>
            <span> {{ infoWindowContent.charger_capacity }} </span>
          </div>
          <div>
            <span>Connector Type:</span>
            <span> {{ infoWindowContent.connector_type }} </span>
          </div>
          <div>
            <span>No of Connecters:</span>
            <span>
              {{ infoWindowContent.no_of_connectors }}
            </span>
          </div>
          <div>
            <span>Available of Connecters:</span>
            <span>
              {{ infoWindowContent.available_connectors }}
            </span>
          </div>

          <div>
            <span>Status:</span>
            <span>
              <status-badge :status="infoWindowContent.location_status" />
              {{ infoWindowContent.location_status }}
            </span>
          </div>
          <div>
            <span>Timings:</span> <span>{{ infoWindowContent.timings }}</span>
          </div>
          <div>
            <span>Last Heartbeat:</span>
            <span
              v-if="
                ![null, undefined, 'N/A'].includes(
                  infoWindowContent?.last_heartbeat_received
                )
              "
            >
              {{ infoWindowContent?.last_heartbeat_received | formatDate }}
            </span>
            <span v-else>N/A</span>
          </div>
        </div>
      </GmapInfoWindow>
    </GmapMap>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GmapCustomMarker from "vue2-gmap-custom-marker";
export default {
  components: {
    GmapCustomMarker,
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    Typography: () => import("@/components/base/Typography.vue"),
  },
  data() {
    return {
      mapCenter: { lat: 30.3753, lng: 69.3451 },
      mapOptions: {
        minZoom: 3,
        scaleControl: true,
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: window.google?.maps.ControlPosition.BOTTOM_RIGHT,
        },
      },
      isControl: true,
      showMap: false,
      isMap: false,
      tab: 0,
      items: [
        { tab: "All Stations", content: "allStations" },
        { tab: "Filters", content: "filters" },
      ],
      infoWindowOpened: false,
      infoWindowPosition: null,
      infoWindowContent: "",

      filters: {}, // ✅ sirf Apply pe use hoga
      tempFilters: {},

      isSelectedAll: true,
      searchLoc: "",
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsLocations/getLoading",
      list: "csmsLocations/getList",
      //
      tenantsOptions: "tenantsManagement/getTenantOptions",
      csoClientsList: "csoClients/getList",
    }),
    isAllSelected() {
      return this.filteredLocations.every((r) => r.selected);
    },
    filteredLocations() {
      let arr = this.list.filter((r) => r.latitude && r.longitude);

      if (this.searchLoc) {
        const regex = new RegExp(this.searchLoc, "i");
        arr = arr.filter((r) => regex.test(r.name));
      }

      // ✅ filters tabhi apply honge jab Apply button click hua hoga
      // if (this.filters.tenantName) {
      //   arr = arr.filter((r) => r.tenant_name === this.filters.tenantName);
      // }
      // if (this.filters.chargerType) {
      //   arr = arr.filter((r) => r.charger_type === this.filters.chargerType);
      // }
      // if (this.filters.chargerCapacity) {
      //   arr = arr.filter(
      //     (r) => r.charger_capacity === this.filters.chargerCapacity
      //   );
      // }
      // if (this.filters.connectorType) {
      //   arr = arr.filter(
      //     (r) => r.connector_type === this.filters.connectorType
      //   );
      // }

      return arr;
    },
    locationsForMap() {
      return this.filteredLocations?.filter((r) => r.selected) || [];
    },
    tenantNames() {
      return this.list.map((r) => ({ id: r.tenant_id, name: r.tenant_name }));
    },
  },
  watch: {
    "tempFilters.tenant_id": {
      handler: function (val) {
        if (val) {
          this.$store.dispatch("csoClients/list", { tenant_id: val });
        } else {
          this.$store.commit("csoClients/SET_LIST", []);
        }
      },
    },
  },
  mounted() {
    this.initMap();
    this.fetchData();

    //
    if (this.authUser.isAdmin) {
      this.$store.dispatch("tenantsManagement/options");
    } else {
      this.tempFilters.tenant_id = this.authUser.tenant_id;
      this.$store.dispatch("csoClients/list", {
        tenant_id: this.authUser.tenant_id,
      });
    }
  },
  methods: {
    initMap() {
      this.isMap = true;
      this.$refs.gmap.$mapPromise.then((map) => {
        if (window.google && window.google.maps) {
          this.mapOptions.fullscreenControlOptions = {
            position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
          };
          map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(
            this.$refs.controlBox
          );
          this.isMap = false;
        }
      });
    },
    async fetchData() {
      const params = {};
      const usr = this.authUser;
      if (!usr.isAdmin) {
        params.tenant_id = usr.tenant_id;
      }

      await this.$store
        .dispatch("csmsLocations/list", params)
        .then(() => this.setMapBounds());
    },
    selectionChange() {
      const val = this.isSelectedAll;
      this.filteredLocations.forEach((el) => {
        el.selected = val;
      });
      this.setMapBounds();
    },
    applyFilters() {
      // this.filters = { ...this.tempFilters }; // ✅ sirf Apply button se filters update
      // this.resetMap();
      this.$store
        .dispatch(`csmsLocations/list`, this.tempFilters)
        .then(() => this.setMapBounds());
    },
    resetMap(val = 1000) {
      this.showMap = false;
      setTimeout(() => (this.showMap = true), val);
    },
    showInfo(v) {
      this.infoWindowPosition = {
        lat: parseFloat(v.latitude),
        lng: parseFloat(v.longitude),
      };
      this.infoWindowContent = v;
      this.infoWindowOpened = true;
    },
    addToMap(v) {
      this.filteredLocations.forEach((el) => {
        if (el.id == v.id) {
          el.selected = !el.selected;
        }
      });
      // this.resetMap(100);
      this.setMapBounds();
    },
    setMapBounds() {
      this.$refs.gmap.$mapPromise.then((map) => {
        if (!this.locationsForMap.length) return;
        const bounds = new window.google.maps.LatLngBounds();
        this.locationsForMap.forEach((v) => {
          if (
            !isNaN(parseFloat(v.latitude)) &&
            !isNaN(parseFloat(v.longitude)) &&
            v.latitude >= -90 &&
            v.latitude <= 90 &&
            v.longitude >= -180 &&
            v.longitude <= 180
          ) {
            bounds.extend(
              new window.google.maps.LatLng(v.latitude, v.longitude)
            );
          }
        });
        map.fitBounds(bounds);
      });
    },

    // setMapBounds() {
    //   if (!this.points.length) return;
    //   const bounds = new window.google.maps.LatLngBounds();
    //   this.points.forEach((coord) => {
    //     bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
    //   });
    //   this.$refs.gmap.$mapObject.fitBounds(bounds);
    // },
    startDrag(e) {
      e.stopPropagation();
      const box = this.$refs.controlBox;
      const parent = box.parentElement;
      const offsetX = e.clientX - box.getBoundingClientRect().left;
      const offsetY = e.clientY - box.getBoundingClientRect().top;
      const parentRect = parent.getBoundingClientRect();

      const onMouseMove = (e) => {
        let newLeft = e.clientX - offsetX;
        let newTop = e.clientY - offsetY;
        const maxLeft = parentRect.width - box.offsetWidth;
        const maxTop = parentRect.height - box.offsetHeight;
        if (newLeft < 0) newLeft = 0;
        if (newTop < 0) newTop = 0;
        if (newLeft > maxLeft) newLeft = maxLeft;
        if (newTop > maxTop) newTop = maxTop;
        box.style.left = `${newLeft}px`;
        box.style.top = `${newTop}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
    endDrag() {},

    //
  },
};
</script>

<style lang="sass" scoped>
$poppinReg: 'Poppins Regular', sans-serif

.map-container
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%

:deep .mapTabsWrap
  max-width: 450px
  min-width: 450px
  z-index: 99
  background: rgba(255,255,255,0.85)

.tabs-header
  padding: 1rem
  display: flex
  flex-wrap: wrap
.toggle-btn
    position: absolute
    right: 1rem
    height: 100%
    display: flex
.searchField
  width: 100%

.control-box
  position: absolute
  top: 1rem
  right: 1rem
  z-index: 9
  cursor: grab
  user-select: none
  transition: none

.row-items
  display: flex
  flex-wrap: wrap
  margin: 0rem 1rem 1rem 1rem
  overflow: hidden
  overflow-y: auto
  max-height: 300px
  .row-item
    display: flex
    flex-wrap: wrap
    background: #f3f3f3
    width: 100%
    padding: 0.5rem 0.75rem
    margin-right: 0.75rem
    margin-bottom: 0.25rem
    :deep .v-input
      margin-top: 0 !important
      .v-input__control
        .v-input__slot
          margin: 0 !important
          .v-label
            font-size: 0.9375rem
            font-family: $poppinReg

        .v-messages
          display: none !important

.offline, .Offline
  .pin-title,.pin-circle,.pin-arrow
    background: #474747ad
    color: white


.online, .Online
  .pin-title,.pin-circle,.pin-arrow
    background: #20a390
    color: white

.pin-icon-container
  user-select: none
  position: relative
  width: 40px
  .pin-title
    position: absolute
    text-align: center
    top: -25px
    left: -10px
    // background: #20a390
    border-radius: 2px
    width: 65px
    font-size: 12px
    font-weight: 800
    padding: 2px
    overflow: hidden
    text-overflow: ellipsis
    display: flex
    white-space: nowrap
    display: inline-block
    box-shadow: 2px 2px 10px 2px gray
  .pin-circle
    padding: 5px
    width: 40px
    height: 40px
    // background-color: #20a390
    border-radius: 50%
    display: flex
    justify-content: center
    align-items: center
    color: white
    font-size: 14px
    font-weight: bold
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3)
    i
      color: #fff !important
  .pin-arrow
    position: absolute
    top: 40px
    left: 15px
    width: 10px
    height: 20px
    // background-color: #20a390
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%)

.info-window
  div
    display: flex
    justify-content: space-between
    align-items: center
    gap: 1rem
    span:last-child
      font-weight: 600

  :deep .status-badge
    display: inline-block

:deep .textEllipsis
  justify-content: flex-end !important
</style>
